module.exports = __webpack_public_path__ + "static/media/CLARICE.cfeaea5f.jpg";